import React, { useState } from 'react';
import { createStructuredSelector } from 'reselect';
import { RootState } from '../../Ribbon/CabinetRibbon/types';
import { makeSelectCabinet } from '../../Configurator/selectors/furniture';
import { Cabinet } from '../../../lib/modelBuilder/entities/Cabinet';
import { useSelector } from 'react-redux';
import {
  arrayPieces,
  createCabinetPiecesList,
} from '../../../lib/modelBuilder/utils/cabinetPiecesList';

// import styled from 'styled-components';

interface StateProps {
  cabinet: Cabinet | null;
}

const StateSelector = createStructuredSelector<RootState, StateProps>({
  cabinet: makeSelectCabinet(),
});

const TestData = () => {
  const [visible, setDisplay] = useState(false);
  const { cabinet } = useSelector(StateSelector);

  const data = JSON.stringify(cabinet, Cabinet.replacer);
  let fullData: any = undefined;
  if (cabinet) {
    const cabinetPieces = createCabinetPiecesList(cabinet);
    const piecesDic = arrayPieces(cabinetPieces);
    const decompo = JSON.stringify(piecesDic);
    fullData = JSON.stringify(
      { cabinet: cabinet, composition: piecesDic },
      Cabinet.replacer,
    );
    // fullData = JSON.stringify(
    //   { cabinet: cabinet, packages: 2 },
    //   Cabinet.replacer,
    // );
  }

  return (
    <>
      <div>
        <button
          // onClick={() => {
          //   setDisplay(!visible);
          // }}
          onClick={() => {
            navigator.clipboard.writeText(fullData);
          }}
          className="border px-3 py-1 rounded text-sm"
        >
          Copy data
        </button>
      </div>
      {visible && fullData && <div className="border m-2 p-2">{fullData}</div>}
    </>
  );
};

export default TestData;
